// react
import { lazy } from 'react';

import AuthLayout from 'layout/AuthLayout';
import Loadable from 'components/Loadable';
import { CLOUD_BASE_PATH } from 'utils/constants';

const CloudMyPage = Loadable(lazy(() => import('pages/Cloud/MyPage')));
const CloudMyPageTop = Loadable(lazy(() => import('pages/Cloud/MyPage/Top')));
const CloudCharge = Loadable(lazy(() => import('pages/Cloud/MyPage/Charge')));
const CloudChargeSelect = Loadable(lazy(() => import('pages/Cloud/MyPage/Charge/select')));
const CloudChargeConfirm = Loadable(lazy(() => import('pages/Cloud/MyPage/Charge/confirm')));
const CloudChargeComplete = Loadable(lazy(() => import('pages/Cloud/MyPage/Charge/complete')));
const CloudCredit = Loadable(lazy(() => import('pages/Cloud/MyPage/Credit')));
const CloudCreditView = Loadable(lazy(() => import('pages/Cloud/MyPage/Credit/view')));
const CloudCreditEdit = Loadable(lazy(() => import('pages/Cloud/MyPage/Credit/edit')));
const CloudCreditConfirm = Loadable(lazy(() => import('pages/Cloud/MyPage/Credit/confirm')));
const CloudCreditComplete = Loadable(lazy(() => import('pages/Cloud/MyPage/Credit/complete')));
const CloudCancel = Loadable(lazy(() => import('pages/Cloud/MyPage/Cancel')));
const CloudCancelSelect = Loadable(lazy(() => import('pages/Cloud/MyPage/Cancel/select')));
const CloudCancelConfirm = Loadable(lazy(() => import('pages/Cloud/MyPage/Cancel/confirm')));
const CloudCancelComplete = Loadable(lazy(() => import('pages/Cloud/MyPage/Cancel/complete')));
const CloudPurchase = Loadable(lazy(() => import('pages/Cloud/MyPage/Purchase')));
const CloudReceipt = Loadable(lazy(() => import('pages/Cloud/MyPage/Purchase/Receipt')));
const CloudCustomerEdit = Loadable(lazy(() => import('pages/Cloud/MyPage/Customer')));
const CloudCustomerConfirm = Loadable(lazy(() => import('pages/Cloud/MyPage/Customer/confirm')));
const CloudCustomerComplete = Loadable(lazy(() => import('pages/Cloud/MyPage/Customer/complete')));
const CloudLoginEdit = Loadable(lazy(() => import('pages/Cloud/MyPage/Login')));
const CloudLoginConfirm = Loadable(lazy(() => import('pages/Cloud/MyPage/Login/confirm')));
const CloudLoginComplete = Loadable(lazy(() => import('pages/Cloud/MyPage/Login/complete')));

const AuthRoutes = {
  path: CLOUD_BASE_PATH.replace(/^\//, ''),
  element: <AuthLayout variant="cloud" />,
  children: [
    {
      path: 'mypage',
      element: <CloudMyPage />,
      children: [
        {
          path: '',
          element: <CloudMyPageTop />
        },
        {
          path: 'charge',
          element: <CloudCharge />,
          children: [
            {
              path: '',
              element: <CloudChargeSelect />
            },
            {
              path: 'confirm',
              element: <CloudChargeConfirm />
            },
            {
              path: 'complete',
              element: <CloudChargeComplete />
            }
          ]
        },
        {
          path: 'credit',
          element: <CloudCredit />,
          children: [
            {
              path: '',
              element: <CloudCreditView />
            },
            {
              path: 'edit',
              element: <CloudCreditEdit />
            },
            {
              path: 'confirm',
              element: <CloudCreditConfirm />
            },
            {
              path: 'complete',
              element: <CloudCreditComplete />
            }
          ]
        },
        {
          path: 'cancel',
          element: <CloudCancel />,
          children: [
            {
              path: '',
              element: <CloudCancelSelect />
            },
            {
              path: ':deviceId',
              element: <CloudCancelConfirm />
            },
            {
              path: 'complete',
              element: <CloudCancelComplete />
            }
          ]
        },
        {
          path: 'purchase',
          element: <CloudPurchase />
        },
        {
          path: 'purchase/:orderId',
          element: <CloudReceipt />
        },
        {
          path: 'customer',
          children: [
            {
              path: '',
              element: <CloudCustomerEdit />
            },
            {
              path: 'confirm',
              element: <CloudCustomerConfirm />
            },
            {
              path: 'complete',
              element: <CloudCustomerComplete />
            }
          ]
        },
        {
          path: 'login',
          children: [
            {
              path: 'edit',
              element: <CloudLoginEdit />
            },
            {
              path: 'confirm',
              element: <CloudLoginConfirm />
            },
            {
              path: 'complete',
              element: <CloudLoginComplete />
            }
          ]
        }
      ]
    }
  ]
};

export default AuthRoutes;
